import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';

export default function ChangeStatus({ model, status, refetch }) {
  const { userToken } = useSelector((state) => state.auth);

  const [formUpdate, { loading }] = useMutation(graph.changeStatus.query, {
    context: {
      serviceName: graph.changeStatus.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const handleChange = async (status_id) => {
    try {
      const { data } = await formUpdate({
        variables: {
          ids: model,
          status_id,
        },
      });
      if (data) {
        const res = data[graph.changeStatus.name];
        res.messages.map((message) => toast.success(String(message)));
        refetch();
      }
    } catch (error) {}
  };

  return (
    <Tooltip title={types[status].title}>
      <Box component='span'>
        <Button
          size="small"
          color="info"
          disableElevation
          variant="contained"
          sx={{ minWidth: 140 }}
          disabled={types[status].disabled}
          onClick={() => handleChange(types[status].nextStep)}
        >
          {loading ? <CircularProgress color="inherit" size={26} /> : types[status].status}
        </Button>
      </Box>
    </Tooltip>
  );
}

const types = {
  // واحد کنترل
  3: {
    nextStep: '5',
    disabled: false,
    title: 'ثبت شده',
    status: 'قبول سفارش',
  },
  9: {
    nextStep: '19',
    disabled: false,
    title: 'تایید دریافت توسط مشتری',
    status: 'تایید عملیات',
  },

  // واحد جمع آوری
  5: {
    nextStep: '6',
    disabled: false,
    title: 'در حال بررسی',
    status: 'جمع آوری شد',
  },
  6: {
    nextStep: '12',
    disabled: false,
    title: 'در حال جمع آوری',
    status: 'بسته بندی شد',
  },

  // واحد تحویل
  12: {
    nextStep: '21',
    disabled: false,
    title: 'بسته بندی شد',
    status: 'تایید دریافت',
  },
  21: {
    nextStep: '24',
    disabled: false,
    title: 'تحویل شده به واحد تحویل',
    status: 'درخواست حمل',
  },
  24: {
    nextStep: '25',
    disabled: true,
    title: 'در جستجوی پیک',
    status: 'در جستجوی پیک',
  },
  25: {
    nextStep: '26',
    disabled: true,
    title: 'در انتظار تحویل به پیک',
    status: 'در انتظار تحویل به پیک',
  },
  26: {
    nextStep: '22',
    disabled: true,
    title: 'تحویل شده به پیک',
    status: 'تحویل به پیک',
  },
  22: {
    nextStep: '9',
    disabled: true,
    title: 'تایید تحویل توسط پیک',
    status: 'تایید تحویل توسط مشتری',
  },
  7: {
    nextStep: '7',
    disabled: true,
    title: 'در حال حمل',
    status: 'در حال حمل',
  },
  8: {
    nextStep: '8',
    disabled: true,
    title: 'در مقصد',
    status: 'در مقصد',
  },
  23: {
    nextStep: '23',
    disabled: false,
    title: 'لغو حمل توسط پیک',
    status: 'لغو حمل توسط پیک',
  },

  // واحد مالی
  4: {
    nextStep: '4',
    disabled: true,
    title: 'مرجوع شده',
    status: 'مرجوع شده',
  },
  10: {
    nextStep: '10',
    disabled: true,
    title: 'لغو توسط کاربر',
    status: 'لغو توسط کاربر',
  },
  11: {
    nextStep: '11',
    disabled: true,
    title: 'لغو توسط سیستم',
    status: 'لغو توسط سیستم',
  },
  16: {
    nextStep: '16',
    disabled: true,
    title: 'اتمام یافته',
    status: 'اتمام یافته',
  },
  19: {
    nextStep: '16',
    disabled: false,
    title: 'تایید تحویل توسط سیستم',
    status: 'تایید سیستم',
  },

  // سبد مشتری
  1: {
    nextStep: '1',
    disabled: true,
    title: 'در انتظار تکمیل اطلاعات',
    status: 'در انتظار تکمیل اطلاعات',
  },
  2: {
    nextStep: '2',
    disabled: true,
    title: 'در انتظار تایید فاکتور',
    status: 'در انتظار تایید فاکتور',
  },
  17: {
    nextStep: '17',
    disabled: true,
    title: 'کالایی برای ذخیره موجود نیست',
    status: 'کالایی برای ذخیره موجود نیست',
  },
  18: {
    nextStep: '18',
    disabled: true,
    title: 'هزینه ی سفارش از حداقل هزینه برای این فروشگاه کمتر است	',
    status: 'هزینه ی سفارش از حداقل هزینه برای این فروشگاه کمتر است	',
  },
  20: {
    nextStep: '28',
    disabled: true,
    title: 'نیاز به بررسی ی مجدد سبد خرید',
    status: 'نیاز به بررسی ی مجدد سبد خرید',
  },
};
